<ion-icon 
    [src]="iconSrc"
    [ngStyle]="iconStyles"
/>